import React from "react";
import { useState } from "react";
import Search from '../components/search/search';
import CurrentWeather from '../components/weather/current-weather';
import {WEATHER_API_URL, WEATHER_API_KEY} from "../api";
import Forecast from '../components/forecast/forecast';

function Weather() {
    const [currentWeather, setCurrentWeather] = useState(null);
    const [forecastWeather, setForecastWeather] = useState(null);

    const handleOnSearchChange = (searchData) => {
      const [latitude, longitude] = searchData.value.split(" ");

      const currentWeatherFetch = fetch(` ${WEATHER_API_URL}/weather?lat=${latitude}&lon=${longitude}&appid=${WEATHER_API_KEY}&units=metric`);
      const forecastWeatherFetch = fetch(` ${WEATHER_API_URL}/forecast?lat=${latitude}&lon=${longitude}&appid=${WEATHER_API_KEY}&units=metric`);

      Promise.all([currentWeatherFetch, forecastWeatherFetch])
      .then(async (response) => {
        const currentWeatherResponse = await response[0].json();
        const forecastWeatherResponse = await response[1].json();

        setCurrentWeather({city:searchData.label , ...currentWeatherResponse});
        setForecastWeather({city:searchData.label , ...forecastWeatherResponse});
      })
      .catch((err) => console.log(err));

    }
    
    return (
      <div id="weather" className="container">
        <Search onSearchChange={handleOnSearchChange}/>
        {currentWeather && <CurrentWeather data={currentWeather}/>}
        {forecastWeather && <Forecast data={forecastWeather}/>}
      </div>
    );

}

export default Weather;